import React from 'react';
import { IconProps } from '../types';
const MinecraftArmorStand: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="7" y="0" width="1" height="1" fill="rgba(95, 73, 40, 255)" />
<rect x="6" y="1" width="1" height="1" fill="rgba(95, 73, 40, 255)" />
<rect x="7" y="1" width="1" height="1" fill="rgba(162, 130, 81, 255)" />
<rect x="8" y="1" width="1" height="1" fill="rgba(61, 48, 30, 255)" />
<rect x="6" y="2" width="1" height="1" fill="rgba(95, 73, 40, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(180, 144, 90, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(61, 48, 30, 255)" />
<rect x="4" y="3" width="1" height="1" fill="rgba(95, 73, 40, 255)" />
<rect x="5" y="3" width="1" height="1" fill="rgba(95, 73, 40, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(95, 73, 40, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(143, 119, 69, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(95, 73, 40, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(95, 73, 40, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(95, 73, 40, 255)" />
<rect x="3" y="4" width="1" height="1" fill="rgba(95, 73, 40, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(162, 130, 81, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(162, 130, 81, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(180, 144, 90, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(162, 130, 81, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(180, 144, 90, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(143, 119, 69, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(180, 144, 90, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(61, 48, 30, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(61, 48, 30, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(61, 48, 30, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(143, 119, 69, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(61, 48, 30, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(143, 119, 69, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(61, 48, 30, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(61, 48, 30, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(95, 73, 40, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(162, 130, 81, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(61, 48, 30, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(162, 130, 81, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(61, 48, 30, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(95, 73, 40, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(180, 144, 90, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(95, 73, 40, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(180, 144, 90, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(61, 48, 30, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(95, 73, 40, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(162, 130, 81, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(95, 73, 40, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(162, 130, 81, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(61, 48, 30, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(95, 73, 40, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(143, 119, 69, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(143, 119, 69, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(162, 130, 81, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(180, 144, 90, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(143, 119, 69, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(61, 48, 30, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(95, 73, 40, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(180, 144, 90, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(61, 48, 30, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(180, 144, 90, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(61, 48, 30, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(95, 73, 40, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(143, 119, 69, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(61, 48, 30, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(162, 130, 81, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(61, 48, 30, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(95, 73, 40, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(162, 130, 81, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(95, 73, 40, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(180, 144, 90, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(61, 48, 30, 255)" />
<rect x="4" y="13" width="1" height="1" fill="rgba(95, 73, 40, 255)" />
<rect x="5" y="13" width="1" height="1" fill="rgba(95, 73, 40, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(180, 144, 90, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(95, 73, 40, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(143, 119, 69, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(61, 48, 30, 255)" />
<rect x="10" y="13" width="1" height="1" fill="rgba(95, 73, 40, 255)" />
<rect x="3" y="14" width="1" height="1" fill="rgba(95, 73, 40, 255)" />
<rect x="4" y="14" width="1" height="1" fill="rgba(168, 168, 168, 255)" />
<rect x="5" y="14" width="1" height="1" fill="rgba(168, 168, 168, 255)" />
<rect x="6" y="14" width="1" height="1" fill="rgba(157, 157, 157, 255)" />
<rect x="7" y="14" width="1" height="1" fill="rgba(168, 168, 168, 255)" />
<rect x="8" y="14" width="1" height="1" fill="rgba(176, 176, 176, 255)" />
<rect x="9" y="14" width="1" height="1" fill="rgba(168, 168, 168, 255)" />
<rect x="10" y="14" width="1" height="1" fill="rgba(176, 176, 176, 255)" />
<rect x="11" y="14" width="1" height="1" fill="rgba(61, 48, 30, 255)" />
<rect x="4" y="15" width="1" height="1" fill="rgba(61, 48, 30, 255)" />
<rect x="5" y="15" width="1" height="1" fill="rgba(61, 48, 30, 255)" />
<rect x="6" y="15" width="1" height="1" fill="rgba(61, 48, 30, 255)" />
<rect x="7" y="15" width="1" height="1" fill="rgba(61, 48, 30, 255)" />
<rect x="8" y="15" width="1" height="1" fill="rgba(61, 48, 30, 255)" />
<rect x="9" y="15" width="1" height="1" fill="rgba(61, 48, 30, 255)" />
<rect x="10" y="15" width="1" height="1" fill="rgba(61, 48, 30, 255)" />
</svg>);
export default MinecraftArmorStand;